<ng-container
  [ngTemplateOutlet]="nodeRenderer"
  [ngTemplateOutletContext]="{ $implicit: nodes() }"
>
</ng-container>

<!--
  Template used to render nodes, this is extracted as a template to allow recustive
  execution when the parser output becomes a tree rather than a simple list (think text
  nodes like bold and italic).
-->
<ng-template #nodeRenderer let-children>
  @for (node of children; track $index) {
    <!-- Due to the way angular handles whitespaces around the control stuctures, we have to use
    this ugly syntax. Any space between the brackets of @if's and @case's and the content gets
    collapsed into one whitespace. In order to eliminate that we need to have the content right after
    the bracket -->
    <!-- prettier-ignore -->
    @switch(node.type) {
      @case ('URL') {<ng-container
        [ngTemplateOutlet]="urlTpl() || defUrlTpl"
        [ngTemplateOutletContext]="{$implicit: node.text, url: node.target}"
      ></ng-container>}
      @case ('VIDEO_POSITION') {<ng-container
          [ngTemplateOutlet]="videoPosTpl() || defaultTextTpl"
          [ngTemplateOutletContext]="{$implicit: node.text, position: node.seconds}"
        ></ng-container>}
      @case ('TEXT') {{{node.text}}}
    }
  }
</ng-template>
<!-- default implementations provided-->
<ng-template #defaultTextTpl let-text>{{ text }}</ng-template>
<ng-template #defUrlTpl let-text let-url="url"
  ><a [href]="url" rel="noopener">{{ text }}</a></ng-template
>
